// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapperButtons[data-v-099423c0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 1rem/* 16px */;\n}\n.flex-1[data-v-099423c0]{\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n", ""]);
// Exports
module.exports = exports;
